const API_PATHS = {
  BASE_PATH: 'https://www.cbr-xml-daily.ru',
  DAILY_PATH: '/daily_json.js',
};

export default API_PATHS;
